<div class="inner-mat-dialog title-section flex content-stretch items-stretch flex-col" style="overflow: scroll;">
  <!-- Title Section -->
  <div mat-dialog-title id="drug-details-header">
    <div class="flex justify-start content-center items-center flex-row">
      <div class="flex flex-row justify-center content-stretch items-stretch h-full basis-1/2">
        <h3>PILL ID WIZARD</h3>
      </div>
      <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
        <mat-icon (click)="this.dialogRef.close()" class="cross-wizard">
          <img src="/assets/img/icons/ico.16.clear.svg" alt="">
        </mat-icon>
      </div>
    </div>
    <div class="flex justify-start content-center items-center flex-row">
      <span>ATORVASTATIN CALCIUM (00071015523)</span>
    </div>
  </div>
  <div class="scroll-div">
    <div class="pill-container-div">
      <div class="pill-info-div">
        <!-- Image Section -->
        <div class="image-section">
          <img [src]="defaultImage" alt="Image" class="image" />
        </div>

        <!-- Buttons Section -->
        <div class="buttons-section">
          <div>
            <span class="label">PIII ID</span>
          </div>
          <div>
            <span class="value">A2412100Z</span>
          </div>

          <button mat-button class="btn-primary btn-sm mt-4" disabled (click)="addNewPillID()">Add a New Pill
            ID</button>
          <button mat-button class="btn-primary btn-sm mt-4" (click)="changePillID()">Change the Pill ID</button>
          <button mat-button class="btn-primary btn-sm mt-4" (click)="removePillID()">Remove the Pill ID</button>
        </div>
      </div>
    </div>
    <div class="drug-table-container">
        <h5>Other Drugs with this Pill ID</h5>
      <div class="other-drug-container" *ngFor="let drug of dataDummy">
        <div>
          <img [src]="drug.image" alt="Drug Image" class="drug-image" />
        </div>
        <div>
          <span> Drug Name </span>
          <span> {{drug.drugName}} </span>
        </div>
        <div>
          <span> Strength </span>
          <span> {{drug.strength}} </span>
        </div>
        <div>
          <span> Unit </span>
          <span> {{drug.unit}} </span>
        </div>
        <div>
          <span> Drug Number </span>
          <span> {{drug.drugNumber}} </span>
        </div>
        <div>
          <span> MFG </span>
          <span> {{drug.mfg}} </span>
        </div>
      </div>
    </div>
  </div>
</div>